<template>
  <div v-if="!loader" class="competence column label">
    <!-- <div class="title">Suas competências</div>
    <ul class="tag selected">
      <li
        v-for="(competence, i) of selected"
        :key="'competencias'+i"
        :id="'competencia'+competence.id_competencia"
        @click="delCompetence(competence, 'competencia'+competence.id_competencia)"
        title="Excluir Competência"
      >
        {{competence.nome}}
        <i class="fa fa-trash"></i>
      </li>
    </ul> 
    <div class="divider"></div>
    -->
    <div class="search fa">
      <input
        type="text"
        class="input"
        v-model="search"
        placeholder="Busque por uma competência"
      />
    </div>
    <div class="noCompetence">
      <br />Não encontrou sua competência?
      <a
        href="https://nscommunity.netsupport.com.br/t/sugestoes-insercao-novas-competencias/2215"
        target="_blank"
        >Clique aqui.</a
      >
    </div>
    <ul class="tag">
      <li
        v-for="(competence, i) of filteredCompetence"
        :key="'competencia' + i"
        @click="addCompetence(competence)"
        title="Adicionar Competência"
      >
        {{ competence.nome }}
        <i class="fa fa-plus"></i>
      </li>
    </ul>
    <div class="divider"></div>

    <div class="tree row column-s">
      <div class="column grid-4 grid-12-s">
        <div class="title">Especialidades</div>
        <ul class="box">
          <li v-for="(especialidades, it) of tree" :key="it">
            <div class="row" @click="showArea(it, !show[it])">
              <div class="grid">{{ it }}</div>
              <strong>
                <i
                  class="fa"
                  :class="!show[it] ? 'fa-chevron-down' : 'fa-chevron-up'"
                ></i>
              </strong>
            </div>
            <transition name="slide">
              <ul class="area" v-if="show[it]">
                <li
                  v-for="(especialidade, ie) of especialidades"
                  :key="ie"
                  class="column"
                  @click="area = area === especialidade ? [] : especialidade"
                >
                  <div class="row">
                    <div class="grid">{{ ie }}</div>
                    <span class="hide-s">
                      <i class="fa fa-chevron-right"></i>
                    </span>
                    <span class="hide-m hide-g">
                      <i
                        class="fa"
                        :class="
                          area === especialidade
                            ? 'fa-chevron-up'
                            : 'fa-chevron-down'
                        "
                      ></i>
                    </span>
                  </div>
                  <transition name="slide">
                    <ul
                      v-if="area === especialidade"
                      class="hide-m hide-g area-mobile"
                    >
                      <li
                        v-for="(a, ia) of area"
                        :key="ia"
                        class="row"
                        @click="addCompetence(a)"
                      >
                        <div class="grid">{{ a.nome }}</div>
                        <strong>
                          <i class="fa fa-plus"></i>
                        </strong>
                      </li>
                    </ul>
                  </transition>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
      </div>
      <div class="column grid-4 grid-12-s hide-s">
        <div class="title">Competências</div>
        <ul :class="area ? 'area' : 'area-hide'" class="box">
          <li
            v-for="(a, ia) of area"
            :key="ia"
            :id="'competencia2' + competence.id_competencia"
            class="row"
            @click="addCompetence(a)"
          >
            <div class="grid">
              {{ a.nome }}
              <i class="fa fa-question-circle font-13 tip">
                <div>{{ a.descricao }}</div>
              </i>
            </div>
            <strong>
              <i class="fa fa-plus"></i>
            </strong>
          </li>
        </ul>
      </div>
      <div class="yours column grid-4 grid-12-s">
        <div class="title">Suas competências</div>
        <div class="box">
          <ul class="tag selected">
            <li
              v-for="(competence, i) of selected"
              :key="'competencias' + i"
              @click="delCompetence(competence)"
              title="Excluir Competência"
            >
              {{ competence.nome }}
              <i class="fa fa-trash"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="save">
      <Button
        layout="green-go"
        @click="
          () => {
            SAVE_COMPETENCE().then(() => {
              if (this.modal.callback) this.modal.callback();
            });
          }
        "
        >Salvar Competências</Button
      >
    </div>
  </div>
  <div v-else class="loader-container column align-center justify-center">
    <Loader />
  </div>
</template>


<script>
import Loader from "@/components/Loader";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Button from "@/components/Button";
export default {
  name: "Competence",
  props: {
    modal: Object,
  },
  components: {
    Button,
    Loader,
  },
  data() {
    return {
      search: "",
      loader: true,
      select: true,
      area: {},
      show: {},
    };
  },
  methods: {
    ...mapActions("user", ["LOAD_COMPETENCE", "SAVE_COMPETENCE"]),
    ...mapMutations("user", ["SET_COMPETENCE"]),
    showArea(i, v) {
      this.show[i] = v;
      this.$forceUpdate();
    },
    addCompetence(competence) {
      this.competence.competencias_selecionadas.push(competence);
      this.area = this.area.filter(
        (c) => c.id_competencia != competence.id_competencia
      );
      this.competence.competencias_disponiveis =
        this.competence.competencias_disponiveis.filter(
          (c) => c.id_competencia != competence.id_competencia
        );
      this.SET_COMPETENCE(this.competence);
      let search = this.search;
      this.search = "";
      this.search = search;
    },
    delCompetence(competence) {
      this.competence.competencias_disponiveis.push(competence);
      if (this.area.length > 0) this.area.push(competence);
      this.competence.competencias_selecionadas =
        this.competence.competencias_selecionadas.filter(
          (c) => c.id_competencia != competence.id_competencia
        );
      this.SET_COMPETENCE(this.competence);
      let search = this.search;
      this.search = "";
      this.search = search;

      this.select = false;
      this.select = true;
    },
  },
  beforeMount() {
    this.LOAD_COMPETENCE().then(() => (this.loader = false));
  },
  computed: {
    ...mapGetters("user", ["competence"]),
    selected() {
      if (this.select)
        return this.competence.competencias_selecionadas
          ? this.competence.competencias_selecionadas
          : [];
      return [];
    },
    filteredCompetence() {
      if (this.competence.competencias_disponiveis) {
        const search = this.search.toLowerCase();
        if (search.length > 2) {
          return this.competence.competencias_disponiveis.filter((c) =>
            c.nome.toLowerCase().includes(search)
          );
        }
      }
      return [];
    },
    tree() {
      let o = {};
      let c = this.competence.competencias_disponiveis;
      c.filter((r) => (o[r.nome_especialidade] = {}));
      c.filter((r) => (o[r.nome_especialidade][r.nome_area] = []));
      c.filter((r) => o[r.nome_especialidade][r.nome_area].push(r));
      return o;
    },
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.competence {
  color: $gray-6;
  padding: 15px;

  .noCompetence {
    text-align: center;
    margin-bottom: 0.8rem;
    margin-top: 0.7rem;
    a {
      text-decoration: underline;
      color: $supporter-2;
    }
  }

  .divider {
    margin-top: 33px;
  }
  .title {
    padding: 20px;
    text-align: center;
    color: $supporter-1;
    font-weight: 500;
  }
  .box {
    @media (min-width: $small) {
      height: 300px;
      overflow-y: auto;
    }
  }
  .tag {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    li {
      border: 1.5px solid $green-4;
      color: $green-4;
      cursor: pointer;
      margin-right: 12px;
      margin-top: 10px;
      border-radius: 100px;
      padding: 5px 10px;
      font-weight: bold;
      &:hover {
        color: $green-2;
        border: 1.5px solid $green-2;
      }
      i {
        margin-left: 5px;
      }
    }
  }
  .selected {
    li:hover {
      background: $white;
      border: 1.5px solid $red-1 !important;
      color: $red-1 !important;
    }
  }
  .search {
    margin-top: 35px;
    input {
      border: none;
      padding: 3px 10px;
      @media (max-width: $small) {
        width: 90%;
      }
    }

    &:after {
      content: "\f002";
      color: $white-4;
      position: absolute;
      margin-left: -35px;
      margin-top: 12px;
      font-size: 23px;
    }
  }
  .save {
    margin-top: 50px;
    text-align: center;
  }
  .tree {
    margin-top: 1.7rem;
    ul.box {
      background: $white;
      border: 1px solid #ddd;
      border-radius: 4px;
      li {
        padding: 15px;

        &:hover {
          color: $blue-2;
          cursor: pointer;
        }
        ul {
          margin-top: 1rem;
          /*     border: 2px solid #ddd; */

          li {
            color: $gray-4;
            font-size: 14px;
            padding: 14px;
            @media (max-width: $small) {
              padding: 25px 20px;
            }
            i {
              font-size: 10px;
            }
          }
        }
      }
    }

    .area {
      @media (min-width: $medium) {
        margin-left: 15px;
      }
      margin-left: 12px;
      background: $white-3;
      li:hover {
        color: $green-2 !important;
      }
      &-hide {
        margin-left: -33%;
      }
      &-mobile {
        background: $white-6;
      }
    }
    .yours {
      @media (min-width: $small) {
        margin-left: 15px;
      }
      @media (max-width: $small) {
        margin-top: 1rem;
      }
    }
    .tag {
      background: $white;
    }
  }
}

.loader-container {
  margin-top: 40px;
  padding: 30px;
}
</style>
